import { TextCapitalized, Spacer, SidePanelDS } from "@qivia/ui";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PublicTransactionsPropsType } from "../transactionsAPI";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { colors } from "@qivia/ui/src/styles/figmaColors";

export const TransactionsDetails = (props: {
  transaction: PublicTransactionsPropsType;
}) => {
  const { t } = useTranslation();
  const hasUnits = (label: string) => {
    return ["mileage", "quantity", "consumption", "carbonEmission"].includes(
      label,
    );
  };
  const transactionInformations = [
    "merchantCity",
    "fuel",
    "mileage",
    "quantity",
    "consumption",
    "carbonEmission",
  ];

  const findKeysToTranslate = useCallback(
    (key: keyof PublicTransactionsPropsType, value: string) => {
      switch (key) {
        case "fuel":
          return t(`transactions.fuel.${value}`);
        default:
          return value;
      }
    },
    [t],
  );

  return (
    <>
      <TextCapitalized>
        <StyledLabel>{t(`transactions.informations.label.title`)}</StyledLabel>
      </TextCapitalized>
      {transactionInformations.map((informationLabel) => {
        const informationDisplay =
          props.transaction[
            informationLabel as keyof PublicTransactionsPropsType
          ];

        const informationDisplayTranslated = findKeysToTranslate(
          informationLabel as keyof PublicTransactionsPropsType,
          informationDisplay as string,
        );

        return (
          <div key={informationLabel}>
            <Spacer y={2} />
            <SidePanelDS.SectionRow
              label={
                <TextCapitalized>
                  <StyledInformations key={informationLabel}>
                    {t(`transactions.informations.label.${informationLabel}`)}
                  </StyledInformations>
                </TextCapitalized>
              }
              value={
                <TextCapitalized>
                  <StyledInformations key={informationLabel}>
                    {!informationDisplay ||
                    informationDisplay.toString() === "0" ? (
                      "-"
                    ) : (
                      <StyledRow>
                        <TextCapitalized>
                          {informationDisplayTranslated}
                        </TextCapitalized>
                        <Spacer x={0.25} />
                        {hasUnits(informationLabel) && (
                          <StyledUnits>
                            <TextCapitalized>
                              {t(
                                `transactions.informations.units.${informationLabel}`,
                              )}
                            </TextCapitalized>
                          </StyledUnits>
                        )}
                      </StyledRow>
                    )}
                  </StyledInformations>
                </TextCapitalized>
              }
            />
          </div>
        );
      })}
    </>
  );
};

const StyledRow = styled.div`
  display: flex;
  align-items: flex-end;
`;

const StyledLabel = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]};
`;
const StyledUnits = styled.div`
  ${typographies["Body/XXS"]}
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledInformations = styled.div`
  ${typographies["Body/L"]};
  color: ${colors["colors/text/black"]};
`;
